import React, { Component } from 'react';
import { findIndex } from 'lodash';
import Dotdotdot from 'react-dotdotdot';
import PropTypes from 'prop-types';

import { getEventDateStringV2 } from '../../../utils/formatting';
import Description from '../../text/Description';
import { LinkAnchor } from '../../Links';
import { getEventRedirectUrl, getUseAnchorForEventLink, isPrivateEvent } from '../../../utils/events';
import { ratingTypes } from '../../../utils/constants';

const _ = { findIndex };

class JuniorCircuitEventCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dimensions: null,
        };
        this.refCallback = this.refCallback.bind(this);
    }

    refCallback(element) {
        if (element) {
            this.setState({
                dimensions: element.getBoundingClientRect(),
            });
        }
    }

    formatEventName(str) {
        return str.replace(/_/g, ' ');
    }

    render() {
        const { dimensions } = this.state;
        const { force = {}, forceCardView, auth, event, isAdminOrOwner, 'data-testid': dataTestId } = this.props;
        const {
            id,
            name,
            isDemoEvent,
            published,
            registeredCount,
            eventDirectors,
            eventState,
            eventLocations,
            utrType,
            currentMember,
            club,
            source,
            teamType,
            utrRange,
            priceRangeShort,
            gender,
            eventRegions,
            hasPrizeMoney,
            prizeMoneyText,
            eventSchedule,
        } = this.props.event;

        const registeredPlayersCount = registeredCount;

        const locationCityStateZip = (eventLocations && eventLocations.length > 0) ? eventLocations[0].display || eventLocations[0].placeName : null;

        let eventName = this.formatEventName(name);
        let eventNameLength = 35;
        if (dimensions && dimensions.width) {
            if (dimensions.width > 300) {
                eventNameLength += 2 * Number((dimensions.width - 300) / 10);
            }
        }
        if (eventName.length > eventNameLength) {
            eventName = `${eventName.substr(0, eventNameLength)}...`;
        }
        const isPlaying = currentMember && (currentMember.playing || currentMember.isPlaying);
        const isOrganizer = (auth && auth.user && auth.user.id && eventDirectors &&
            (_.findIndex(eventDirectors, { memberId: auth.user.id }) !== -1)) ||
            (currentMember && currentMember.eventDirectorRole) || isAdminOrOwner;

        /* Description items desktop */
        const descriptionLine1 = [locationCityStateZip];
        if ((isOrganizer || (event && event.playerCountVisibility)) && registeredPlayersCount > 0) {
            descriptionLine1.push(`${registeredPlayersCount} ${'Playing'}`);
        }

        const isImportedEvent = source === 'scraped-import';
        const isClubMember = (auth && auth.user && auth.user.id && club &&
            (_.findIndex(auth.user.clubMemberships, { clubId: club.id }) !== -1));
        const showMemberEventTag = isPrivateEvent(this.props.event) && !isClubMember;

        const colorStateV2 = () => {
            switch (eventState && eventState.value) {
                case 'pre_registration':
                case 'completed':
                    return 'gray';
                case 'in_progress':
                    return '';
                default:
                    return '';
            }
        };

        const getTag = (block, tagPrefix) => {
            if (!published) {
                return <div className={`tag tag-gray tag-xs ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>Draft</div>;
            }
            if (isPlaying && isOrganizer) {
                return (
                    <div className="ml-auto">
                        <div className={`tag tag-${colorStateV2()} tag-xs mr8`} data-testid={tagPrefix && `${tagPrefix}.player-tag`}>Player</div>
                        <div className={`tag tag-${colorStateV2()} tag-xs`} data-testid={tagPrefix && `${tagPrefix}.organizer-tag`}>Provider</div>
                    </div>
                );
            } if (isPlaying) {
                return <div className={`tag tag-${colorStateV2()} tag-xs ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.player-tag`}>Player</div>;
            } if (isOrganizer) {
                return <div className={`tag tag-${colorStateV2()} tag-xs ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.organizer-tag`}>Provider</div>;
            }
            if (showMemberEventTag) {
                return <div className={`tag tag-gray tag-xs ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>Member Event</div>;
            }

            switch (eventState && eventState.value) {
                case 'pre_registration':
                    return (
                        <div className={`tag tag-gray tag-xs ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>
                            <span className={`d-block d-lg-none`} data-testid={tagPrefix && `${tagPrefix}.status-tag.short`}>Pre Reg</span>
                            <span className={`d-none d-lg-block`} data-testid={tagPrefix && `${tagPrefix}.status-tag.long`}>Pre Registration</span>
                        </div>
                    );
                case 'open_registration':
                    return (
                        <div className={`tag tag-outline tag-xs ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>
                            <span className={`d-block d-lg-none`} data-testid={tagPrefix && `${tagPrefix}.status-tag.short`}>Reg Open</span>
                            <span className={`d-none d-lg-block`} data-testid={tagPrefix && `${tagPrefix}.status-tag.long`}>Registration Open</span>
                        </div>
                    );
                case 'registration_closed':
                    return (
                        <div className={`tag tag-gray tag-xs ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>
                            <span className={`d-block d-lg-none`} data-testid={tagPrefix && `${tagPrefix}.status-tag.short`}>{isImportedEvent ? 'Scheduled' : 'Reg Closed'}</span>
                            <span className={`d-none d-lg-block`} data-testid={tagPrefix && `${tagPrefix}.status-tag.long`}>{isImportedEvent ? 'Scheduled' : 'Registration Closed'}</span>
                        </div>
                    );
                case 'in_progress':
                    return <div className={`tag tag-xs ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>In Progress</div>;
                case 'completed':
                    return <div className={`tag tag-gray tag-xs ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>Completed</div>;
                default:
                    return <div />;
            }
        };

        const clubDetails = [club?.name];
        clubDetails.push(locationCityStateZip);

        const descriptionMobileLine1V2 = [];
        const descriptionMobileLine2V2 = [];

        if (hasPrizeMoney && prizeMoneyText) {
            descriptionMobileLine1V2.push(prizeMoneyText);
        }

        if ((isOrganizer || (event && event.playerCountVisibility)) && registeredPlayersCount > 0) {
            descriptionMobileLine2V2.push(`${registeredPlayersCount} Playing`);
        }

        if (utrRange) {
            descriptionMobileLine2V2.push(`${ratingTypes.tennis} ${utrRange}`);
        }
        if (priceRangeShort) {
            descriptionMobileLine1V2.push(`${priceRangeShort}`);
        }
        if (gender) {
            descriptionMobileLine2V2.push(gender);
        }
        if (teamType) {
            descriptionMobileLine2V2.push(teamType);
        }

        let eventDateString;
        if (eventSchedule) {
            eventDateString = getEventDateStringV2(eventSchedule);
        }

        return (
            <div style={showMemberEventTag ? { pointerEvents: 'none' } : {}}>
                <LinkAnchor
                    link={getEventRedirectUrl(id, source)}
                    useAnchor={getUseAnchorForEventLink(source)}
                    target={'_self'}
                    data-testid={dataTestId && `${dataTestId}.card-link`}
                >
                    <div
                        // eslint-disable-next-line max-len
                        className={`utr-card event-card ${force && force.large ? 'event-card-large' : ''} ${force && force.featured ? 'event-card-featured' : ''}`}
                    >
                        <div className={`list-view ${forceCardView || force.cardView ? 'd-none' : 'd-none d-md-block'}`}>
                            <div className="d-flex">
                                <div className="flex-grow">
                                    <div className="row">
                                        <div className="d-grid w-100" style={{ gridTemplateColumns: '0.2fr 3fr 1fr 1fr 1fr 1fr 1.5fr 1.5fr 1.5fr', columnGap: '10px' }}>
                                            <div>
                                                {(utrType && utrType.value === 'sanctioned') && (
                                                    <div className={`utr-icon icon-verified-blue mt4`} title="Sanctioned" />
                                                )}
                                            </div>
                                            <div className="d-flex content-wrapper show-ellipsis">
                                                <div className="club-and-name">
                                                    {/* <div className="club-name show-ellipsis">{club?.name}</div> */}
                                                    <div className={`name ${utrType && utrType.value === 'sanctioned' ? 'hasSanctioned' : ''} show-ellipsis`} title={name} data-testid={dataTestId && `${dataTestId}.desktop.name`}>
                                                        {isDemoEvent ? '[DEMO] ' : ''}{this.formatEventName(name)}
                                                    </div>
                                                </div>
                                                <div className="club-and-name">
                                                    <div className="club-name show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.club-name`}>{club?.name}</div>
                                                </div>
                                                <div className="description">
                                                    <div>
                                                        <Description desc={descriptionLine1} data-testid={dataTestId && `${dataTestId}.desktop.description-line1`} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`d-flex aic`}>
                                                <div className="values text-lighter" data-testid={dataTestId && `${dataTestId}.desktop.region`}>
                                                    {eventRegions && eventRegions[0]?.region?.label}
                                                </div>
                                            </div>
                                            <div className={`d-flex aic`}>
                                                <div className="values text-lighter" data-testid={dataTestId && `${dataTestId}.desktop.price`}>
                                                    {priceRangeShort}
                                                </div>
                                            </div>
                                            <div className={`d-flex aic`}>
                                                <div className="values text-lighter" data-testid={dataTestId && `${dataTestId}.desktop.utr-range`}>
                                                    {utrRange}
                                                </div>
                                            </div>
                                            <div className={`d-flex aic`}>
                                                <div className="values text-lighter" data-testid={dataTestId && `${dataTestId}.desktop.gender`}>
                                                    {gender}
                                                </div>
                                            </div>
                                            <div className={`d-flex aic`}>
                                                <div className="values text-lighter" data-testid={dataTestId && `${dataTestId}.desktop.team-type`}>
                                                    {teamType}
                                                </div>
                                            </div>
                                            <div className="d-flex aic date">
                                                <div className="values text-lighter" data-testid={dataTestId && `${dataTestId}.desktop.date`}>
                                                    {eventDateString}
                                                </div>
                                            </div>
                                            <div className={`d-flex aic`}>
                                                {getTag(false, dataTestId && `${dataTestId}.desktop`)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            // eslint-disable-next-line max-len
                            className={`card-view ${forceCardView || force.cardView ? 'd-block' : 'd-block d-md-none'} ${force && force.small ? 'card-small' : ''}`}
                            ref={this.refCallback}
                        >
                            <div className="content-wrapper">
                                <div className="club-and-name">
                                    <div className="date">
                                        <span data-testid={dataTestId && `${dataTestId}.mobile.date`}>{eventDateString}</span>
                                        {getTag(false, dataTestId && `${dataTestId}.mobile`)}
                                    </div>
                                    <div className={`name ${utrType && utrType.value === 'sanctioned' ? 'hasSanctioned' : ''}`} title={name} data-testid={dataTestId && `${dataTestId}.mobile.name`}>
                                        <Dotdotdot clamp={2}>{this.formatEventName(name)}
                                            <div className={`badge-wrapper`}>
                                                {(utrType && utrType.value === 'sanctioned') &&
                                                    <div className={`utr-icon icon-verified-blue`} title="Sanctioned" data-testid={dataTestId && `${dataTestId}.mobile.sanctioned-badge`} />}
                                            </div>
                                        </Dotdotdot>
                                    </div>
                                    <div className="club-name show-ellipsis" data-testid={dataTestId && `${dataTestId}.mobile.club-name`}><Description desc={clubDetails} data-testid={dataTestId && `${dataTestId}.mobile.club-name`} /></div>
                                </div>
                                <div className="description">
                                    <div>
                                        <Description desc={descriptionMobileLine1V2} data-testid={dataTestId && `${dataTestId}.mobile.description-line1`} />
                                    </div>
                                    <div>
                                        <Description desc={descriptionMobileLine2V2} data-testid={dataTestId && `${dataTestId}.mobile.description-line2`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </LinkAnchor>
            </div>
        );
    }
}

JuniorCircuitEventCard.propTypes = {
    auth: PropTypes.objectOf(PropTypes.any).isRequired,
    force: PropTypes.objectOf(PropTypes.any),
    forceCardView: PropTypes.bool,
    event: PropTypes.objectOf(PropTypes.any).isRequired,
    isAdminOrOwner: PropTypes.bool,
    'data-testid': PropTypes.string,
};
JuniorCircuitEventCard.defaultProps = {
    force: {},
    forceCardView: false,
    isAdminOrOwner: false,
    'data-testid': null,
};

export default JuniorCircuitEventCard;
